// Embed context injected by parent window via URL params when CG is embedded in an iframe.
// requirement_id scopes the session to a specific requirement, affecting generation storage and library filtering.

const params = new URLSearchParams(window.location.search)

export const embedRequirementId: string | null = params.get('requirement_id')
